import { registerBlockDirectionNormalization } from '#pplx/frontend/composer-sdk/internal/input/transforms/blockDirectionNormalization.js';
import { paragraphNodeTransform } from '#pplx/frontend/composer-sdk/internal/input/transforms/paragraphNodeTransform.js';
import { rootNodeTransform } from '#pplx/frontend/composer-sdk/internal/input/transforms/rootNodeTransform.js';
import { textNodeTransform } from '#pplx/frontend/composer-sdk/internal/input/transforms/textNodeTransform.js';
import { getTextDirection } from '#pplx/frontend/i18n/core.js';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
export function useComposerInputTransforms({ editor }) {
    const { locale } = useIntl();
    const localeDirection = getTextDirection(locale);
    useEffect(() => {
        if (!editor)
            return;
        const textNodeTransformCleanup = textNodeTransform({ editor });
        const rootNodeTransformCleanup = rootNodeTransform(editor);
        const paragraphNodeTransformCleanup = paragraphNodeTransform(editor);
        const directionNormalizationCleanup = registerBlockDirectionNormalization(editor, localeDirection);
        return () => {
            textNodeTransformCleanup();
            rootNodeTransformCleanup();
            paragraphNodeTransformCleanup();
            directionNormalizationCleanup();
        };
    }, [editor, localeDirection]);
}
//# sourceMappingURL=useComposerInputTransforms.js.map